﻿import * as React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { Translate } from '../../../../../../shared/LanguageService';
import { getBrokerSystemHelpContent } from '../../../../../../shared/ContentProvider';

interface IProps {
    brokerSystem: string;
    isLoading?: boolean;
    brokerSystemId: number;
}

export const BrokerSystemModalHelpSection = (props: IProps) => {
    const helpImage = getBrokerSystemHelpContent(props.brokerSystemId);
    return (
        <Box>
            {props.isLoading ? (
                <Box
                    sx={{
                        border: '1px solid #e0e0e0',
                        borderRadius: 1,
                        p: 3,
                        mb: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: 120,
                    }}
                >
                    <CircularProgress size={48} sx={{ mb: 1 }} />
                    <Typography>{Translate('view-order/basic-order-info/modal/creating-connection')}</Typography>
                </Box>
            ) : (
                <Box mx={3} mb={3} p={3} border={1} borderColor="grey.300" borderRadius={1}>
                    <Typography fontWeight="bold" mb={2}>
                        {Translate('view-order/basic-order-info/modal/help-find-object-id', {
                            brokerSystem: props.brokerSystem
                        })}
                    </Typography>
                    <Box
                        component="img"
                        src={helpImage}
                        alt={'Help section image, objectId'}
                        sx={{ width: '100%', borderRadius: 1 }}
                    />
                </Box>
            )}
        </Box>
    );
};
